module.exports = __webpack_public_path__ + "img/pirate-fountain_1.dc7de894.jpg";